module.exports = __webpack_public_path__ + "static/media/2nd-dotmobile.b8fe7174.png";